type Wheel = {
  wheelDelta: number
}

export function attachWheel(element: HTMLElement): () => void {
  const state = {
    time: 0, // scroll start
    left: 0, // left in pricess
  }

  function getTargetLeft() {
    const old = Date.now() > state.time + 200
    if (old) return element.scrollLeft
    return state.left
  }

  function onWeel(event: WheelEvent) {
    if (event.shiftKey || event.ctrlKey || event.altKey) return

    const target = getTargetLeft()
    const max = element.scrollWidth - element.clientWidth
    const delta = (event as unknown as Wheel).wheelDelta

    let left = target - delta
    left = Math.max(0, Math.min(max, left))

    const scroll = left !== target
    const pause = Date.now() < state.time + 1000
    if (scroll || pause) event.preventDefault()

    if (!scroll) return

    state.time = Date.now()
    state.left = left
    const behavior = 'smooth'
    element.scrollTo({ left, behavior })
  }

  element.addEventListener('wheel', onWeel)

  return () => {
    element.removeEventListener('wheel', onWeel)
  }
}
